import { render } from "./Hero.vue?vue&type=template&id=2afbf1f2&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=2afbf1f2&scoped=true&lang=css"

import exportComponent from "/media/gubbi/51C0A8CA04B85949/Ubuntu/home/tp/e-menu/2.0.0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afbf1f2"]])

export default __exports__